export default {
  projects: [],
  selectedProject: {},
  selectedProjectPermissions: [],
  projectStages: [],
  selectedProjectStage: {},
  partners: [],
  selectedPartner: {},
  partnersTotalCount: 0
}
